/* PROMOCOLOUR — header: mobile menu + AJAX cart drawer */
(function () {
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- focus management for modal surfaces (drawer + menu) ---------- */
  function focusables(panel) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function trapTab(e, panel) {
    if (e.key !== 'Tab') return;
    var f = focusables(panel);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  var lastFocus = null; // element to restore focus to when a surface closes

  /* ---------- mobile menu ---------- */
  var menu = $('[data-pc-menu]');
  var menuPanel = menu ? ($('.pc-hd__drawer-panel', menu) || menu) : null;
  function openMenu() {
    if (!menu) return;
    lastFocus = document.activeElement;
    menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    var f = focusables(menuPanel); if (f.length) f[0].focus();
  }
  function closeMenu() {
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  $$('[data-pc-menu-open]').forEach(function (b) { b.addEventListener('click', openMenu); });
  $$('[data-pc-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  var body = $('[data-pc-cart-body]');
  var foot = $('[data-pc-cart-foot]');

  function setCount(n) { $$('[data-pc-cart-count]').forEach(function (e) { e.textContent = n; e.hidden = n === 0; }); }

  function itemHTML(it, line) {
    var props = '';
    if (it.properties) {
      Object.keys(it.properties).forEach(function (k) {
        if (k.charAt(0) !== '_' && it.properties[k]) props += '<span>' + esc(k) + ': ' + esc(it.properties[k]) + '</span>';
      });
    }
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_140x$1$2') : '';
    return '<div class="pc-cd__item" data-line="' + line + '">' +
      (img ? '<a href="' + esc(it.url) + '" class="pc-cd__item-img"><img src="' + esc(img) + '" alt=""></a>' : '') +
      '<div class="pc-cd__item-info">' +
      '<a href="' + esc(it.url) + '" class="pc-cd__item-title">' + esc(it.product_title) + '</a>' +
      (it.variant_title ? '<span class="pc-cd__item-variant">' + esc(it.variant_title) + '</span>' : '') +
      (props ? '<div class="pc-cd__item-props">' + props + '</div>' : '') +
      '<div class="pc-cd__item-row">' +
      '<div class="pc-cd__qty"><button type="button" data-cd-minus aria-label="Decrease">&minus;</button><span data-cd-q>' + it.quantity + '</span><button type="button" data-cd-plus aria-label="Increase">+</button></div>' +
      '<span class="pc-cd__item-price">' + money(it.final_line_price) + '</span>' +
      '</div>' +
      '<button type="button" class="pc-cd__remove" data-cd-remove>Remove</button>' +
      '</div></div>';
  }

  function render(cart) {
    setCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div class="pc-cd__empty">Your cart is empty.</div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) { return itemHTML(it, i + 1); }).join('');
    var sub = $('[data-pc-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    if (foot) foot.hidden = false;
    wireItems();
  }

  function change(line, qty) {
    body.classList.add('is-loading');
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { body.classList.remove('is-loading'); render(cart); });
  }

  function wireItems() {
    $$('[data-pc-cart-body] .pc-cd__item').forEach(function (el) {
      var line = parseInt(el.getAttribute('data-line'), 10);
      var q = function () { return parseInt($('[data-cd-q]', el).textContent, 10) || 1; };
      $('[data-cd-plus]', el).addEventListener('click', function () { change(line, q() + 1); });
      $('[data-cd-minus]', el).addEventListener('click', function () { change(line, Math.max(0, q() - 1)); });
      $('[data-cd-remove]', el).addEventListener('click', function () { change(line, 0); });
    });
  }

  var drawerPanel = drawer ? ($('.pc-cd__panel', drawer) || drawer) : null;
  function openCart() {
    if (!drawer) { window.location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      render(cart);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = $('[data-pc-cart-close]', drawer);
      if (closeBtn) closeBtn.focus();
    });
  }
  function closeCart() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  $$('[data-pc-cart-open]').forEach(function (b) { b.addEventListener('click', openCart); });
  $$('[data-pc-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (drawer) { drawer.open = openCart; }                       // lets the quote wizard's "Keep browsing" open it
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); return; }
    if (e.key === 'Tab') {
      if (drawer && drawer.classList.contains('is-open')) { trapTab(e, drawerPanel); }
      else if (menu && menu.classList.contains('is-open')) { trapTab(e, menuPanel); }
    }
  });

  /* ---------- desktop nav dropdown keyboard a11y ---------- */
  $$('.pc-hd__menu-item.has-sub').forEach(function (item) {
    var link = $('.pc-hd__menu-link', item);
    if (!link) return;
    item.addEventListener('focusin', function () { link.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) link.setAttribute('aria-expanded', 'false');
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        link.setAttribute('aria-expanded', 'false');
        link.focus();
      }
    });
  });

  /* ---------- predictive search ---------- */
  var sWrap = $('[data-pc-search]');
  if (sWrap) {
    var sInput = $('[data-pc-search-input]', sWrap);
    var sPanel = $('[data-pc-search-panel]', sWrap);
    var sTimer;
    function hideSearch() { sPanel.hidden = true; sPanel.innerHTML = ''; }
    sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      clearTimeout(sTimer);
      if (q.length < 2) { hideSearch(); return; }
      sTimer = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          var res = (data.resources && data.resources.results) || {};
          var prods = res.products || [], links = (res.collections || []).concat(res.pages || []);
          if (!prods.length && !links.length) {
            sPanel.innerHTML = '<div class="pc-hd__search-empty">No results for &ldquo;' + esc(q) + '&rdquo;</div>';
            sPanel.hidden = false; return;
          }
          var html = prods.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            return '<a class="pc-hd__search-item" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="">' : '<span class="pc-hd__search-noimg"></span>') +
              '<span class="pc-hd__search-item-t">' + esc(p.title) + '</span></a>';
          }).join('');
          if (links.length) {
            html += '<div class="pc-hd__search-links">' + links.map(function (l) {
              return '<a href="' + esc(l.url) + '">' + esc(l.title) + '</a>';
            }).join('') + '</div>';
          }
          sPanel.innerHTML = html; sPanel.hidden = false;
        }).catch(hideSearch);
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!sWrap.contains(e.target)) hideSearch(); });
    sInput.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideSearch(); });
  }

  /* ---------- search is dropdown-only: never navigate to the /search results page ---------- */
  $$('form[role="search"]').forEach(function (f) { f.addEventListener('submit', function (e) { e.preventDefault(); }); });
})();
